//@Flow
import React, {useEffect, useContext, Suspense, lazy} from 'react';
import './App.css';
import {Switch, Route, Redirect} from 'react-router-dom'
import SecureContainer from "./components/SecureContainer/SecureContainer";
import BlocRegistry from './blocs/registry'
import LoadingMessage from "./components/LoadingMessage/LoadingMessage";
import Flexbox from "flexbox-react";

// Top-level routes are code-split so a visitor's initial bundle only pulls in
// the one they land on (e.g. /login) instead of the entire app graph.
const AppView = lazy(() => import("./views/AppView/AppView"));
const LoginView = lazy(() => import("./views/LoginView/LoginView"));
const AuthCallbackView = lazy(() => import("./views/AuthCallbackView/AuthCallbackView"));
const Forbidden = lazy(() => import("./views/Forbidden/Forbidden"));
const SharedFilesView = lazy(() => import("./views/SharedFilesView/SharedFilesView"));

const SecureAppView = SecureContainer(AppView);

const RouteFallback = () => (
    <Flexbox justifyContent={'center'} alignContent={'center'} alignItems={'center'} width={'100vw'} height={'100vh'}>
        <LoadingMessage message={"LOADING"}/>
    </Flexbox>
);

function App() {
    const blocRegistry = useContext(BlocRegistry);

    useEffect(() => {
        return () => {
            Object.values(blocRegistry).forEach(bloc => {
                if (bloc && typeof bloc.dispose === 'function') {
                    bloc.dispose();
                }
            });
        }
    }, []);

    return (
        <BlocRegistry.Provider value={blocRegistry}>
            <div className="App App-container">
                <Suspense fallback={<RouteFallback />}>
                    <Switch>
                        <Redirect from="/" exact to="/app" />
                        <Route path='/app' render={(props) => <SecureAppView {...props} />} />
                        <Route path='/login' render={(props) => <LoginView {...props} />} />
                        <Route path='/auth/callback' render={(props) => <AuthCallbackView {...props} />} />
                        <Route path='/forbidden' render={(props) => <Forbidden {...props} />} />
                        {/* Public, unauthenticated recipient page for emailed photos/attachments */}
                        <Route path='/shared-files/:token' render={(props) => <SharedFilesView {...props} />} />
                    </Switch>
                </Suspense>
            </div>
        </BlocRegistry.Provider>
    );
}

export default App;
